import { render, staticRenderFns } from "./credit-statement.vue?vue&type=template&id=cfe53374&scoped=true"
import script from "./credit-statement.vue?vue&type=script&lang=js"
export * from "./credit-statement.vue?vue&type=script&lang=js"
import style0 from "./credit-statement.vue?vue&type=style&index=0&id=cfe53374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe53374",
  null
  
)

export default component.exports